import React from 'react'
import { Input } from 'antd'
import { CustomSelect } from 'components'
import { MBSelect } from 'pages/MyBackOffice/MBComponents'
import SearchIcon from 'images/input-search.svg'
import closeIconSvg from 'images/Crossmark.svg'
import { getNameByKey } from 'utils'
// import { throttle } from 'lodash'
import c from 'classnames'
import './index.styl'

const ULControlPanel = ({
  search,
  setSearch,
  sort,
  setSort,
  statusesActive,
  onChangeSearch,
  setStatusesActive,
  loading,
  statuses,
  setStatuses,
}) => {
  const sortByItems = [
    { name: 'Sort by Date', key: 'DATE_ASC' },
    { name: 'Sort by Date', key: 'DATE_DESC' },
    { name: 'Sort by Name', key: 'NAME_ASC' },
    { name: 'Sort by Name', key: 'NAME_DESC' },
  ]
  const filterByStatuses = [
    { name: 'Admin', key: 'admin' },
    { name: 'Buyer', key: 'buyer' },
    { name: 'Promoter', key: 'promoter' },
    { name: 'Promoter Partner', key: 'promoterPartner' },
    { name: 'Venue', key: 'venue' },
  ]

  const filterByVefivied = [
    { name: 'Verified', key: 'verified' },
    { name: 'Unverified', key: 'unverified' },
  ]

  const handleClearAll = () => {
    if (!loading) {
      setStatusesActive([])
      setStatuses([])
    }
  }
  const renderClearItem = (statuses, setStatus) => status => {
    return (
      <div key={status} className={c('clearStatus', { disabled: loading })}>
        {getNameByKey(status, [...filterByStatuses, ...filterByVefivied])}
        <span className='clearIcon' onClick={() => !loading && setStatus(statuses.filter(s => s !== status))}>
          <img src={closeIconSvg} alt=' ' />
        </span>
      </div>
    )
  }
  const renderStatusesIndicator = [...statusesActive].length ? (
    <>
      {statusesActive.map(renderClearItem(statusesActive, setStatusesActive))}
      {statuses.map(renderClearItem(statuses, setStatuses))}
      <div className={c('clearStatus clearAll', { disabled: loading })} onClick={handleClearAll}>Clear All Filters</div>
    </>
  ) : null

  return (
    <div className='ULControlPanel'>
      <div className='mboLeftBlock'>
        <Input
          onChange={onChangeSearch}
          prefix={<img alt='search icon' src={SearchIcon} />}
          className='input noFocusBorder'
          placeholder='Search'
          // value={search}
          allowClear
        />
        <div className='mdVisible'>
          {renderStatusesIndicator}
        </div>
      </div>
      <div className='mboRightBlock'>
        <CustomSelect
          setSortTag={tag => setSort(tag)}
          items={sortByItems}
          disabled={loading}
          sortTag={sort}
          customSuffix
          className='ulSort'
        />
        <MBSelect
          placeholder='Filter by status'
          setValues={setStatusesActive}
          options={filterByStatuses}
          values={statusesActive}
          className='mboSelect'
          disabled={loading}
        />
        <MBSelect
          placeholder='Filter by status'
          setValues={setStatuses}
          className='mboSelectFilter'
          options={filterByVefivied}
          values={statuses}
          disabled={loading}
        />
        <div className='xsVisible'>
          {renderStatusesIndicator}
        </div>
      </div>
    </div>
  )
}

export default ULControlPanel
